import { Chip } from '@mui/material';
import { IntegrationStatus } from '../../model/types';

const STATUS_COLOR_MAP: Record<IntegrationStatus, { backgroundColor: string; color: string }> = {
  [IntegrationStatus.connected]: { backgroundColor: '#198754', color: 'white' },
  [IntegrationStatus.pending]: { backgroundColor: '#E7ECFA', color: '#646874' },
  [IntegrationStatus.failed]: { backgroundColor: 'error.main', color: 'white' },
};

const LABELS: Record<IntegrationStatus, string> = {
  [IntegrationStatus.connected]: 'Connected',
  [IntegrationStatus.pending]: 'Pending',
  [IntegrationStatus.failed]: 'Error',
};

interface Props {
  status: IntegrationStatus;
}

export function IntegrationStatusIndicator({ status }: Props) {
  return (
    <Chip
      sx={{
        height: 22,
        fontSize: '0.75rem',
        lineHeight: '0.875rem',
        ...STATUS_COLOR_MAP[status],
      }}
      size="small"
      label={LABELS[status]}
    />
  );
}
